import PropTypes from "prop-types";
import React from "react";
import OutputForm from "./OutputForm";
import { useMeasureUnits } from "@aetonix/hooks";

export default function OutputReading(props){
	var schema = props.schema;
	var indicator = schema.indicator;

	const measureUnits = useMeasureUnits();

	var data = formatOutput(props.data, indicator, measureUnits);
	return (
		<OutputForm schema={schema} data={data} style={props.style} />
	);
}

function formatOutput(data, indicator, measureUnits){
	const { weightUnits, glucometerUnits, temperatureUnits } = measureUnits;

	if(!data) return data;
	if(indicator === "bloodsugar"){
		const units = glucometerUnits;
		const displayUnits = glucometerUnits === "mg" ? "mg/dL" : "mmol/L";
		return {
			glucose: data[units] + " " + displayUnits
		};
	} else if (indicator === "weight"){
		const units = weightUnits;
		return {
			weight: data[units] + " " + units
		};
	} else if (indicator === "bodytemperature"){
		const units = temperatureUnits;
		return {
			bodytemperature: data[units] + " \u00B0" + units[0].toUpperCase()
		};
	} else if (indicator === "bloodoxygen"){
		return {
			oxygensaturation: data.oxygensaturation + "%",
			pulserate: data.pulserate + " bpm"
		};
	} else if (indicator === "bloodpressure"){
		return {
			bloodpressure: data.systolic + "/" + data.diastolic + " mmHg",
			systolic: data.systolic + " mmHg",
			diastolic: data.diastolic + " mmHg"
		};
	} else return data;
}

